import qs from 'query-string';

export const getCachedSearch = () => {
    let item = localStorage.getItem('searchObj')
    if (item) {
        item = JSON.parse(item)
    }

    return item;
}

export const buildSearchObj = (querystring) => {
    const qsObj = qs.parse(querystring, { arrayFormat: 'comma' });
    if (typeof qsObj.jobSearchQueries === 'string') {
        qsObj.jobSearchQueries = [qsObj.jobSearchQueries]
    }
    return qsObj;
}

export const hasValidCachedSearch = () => {
    let hasValidCachedParams = localStorage.getItem('searchParams');
    if (hasValidCachedParams) {
        hasValidCachedParams = JSON.parse(hasValidCachedParams)
        hasValidCachedParams = !!hasValidCachedParams.jobSearchQueries?.length;
    }
    return hasValidCachedParams;
}